import { ModKeys } from "@intelligems/ig-types/fe-only/personalizations";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  addVariationMod,
  removeVariationMod,
  setModActivated,
} from "@src/store/slices/experienceInfoState";

/**
 * Turns a mod on for exactly these variations and off for the rest, the same
 * way the editor does when a section is added or deleted. Post-purchase,
 * checkout and offer tests only show a section whose mod is on. It's for an
 * action that replaces all of a mod's content at once, like Ellie's redirect
 * and CSS/JS actions, so a variation the new content leaves out loses the mod.
 * Experiments keep a list per variation. Personalizations keep one flat list,
 * so the mod is on when any variation has content, and `setModActivated` is an
 * on/off switch, so it's only dispatched when the mod needs to flip.
 */
export const setModForVariations = createAsyncThunk<
  void,
  { mod: ModKeys; variationIds: string[] }
>(
  "checkoutBlocks/setModForVariations",
  ({ mod, variationIds }, { dispatch, getState }) => {
    const state = getState();
    if (state.experience.experience?.category === "experiment") {
      for (const { id } of state.variations.variations) {
        dispatch(
          variationIds.includes(id)
            ? addVariationMod({ variationId: id, mod })
            : removeVariationMod({ variationId: id, mod })
        );
      }
    } else {
      const isModOn = state.experienceInfoState.activatedModArr.includes(mod);
      const shouldModBeOn = variationIds.length > 0;
      if (isModOn !== shouldModBeOn) {
        dispatch(setModActivated({ key: mod }));
      }
    }
  }
);
